import { type ReactNode } from 'react';

import Typography from '@liquidweb-dev/undercurrent/Typography';

const DestroyNote = ({ children }: { children: ReactNode }) => {
	return (
		<Typography variant="body-md">
			<Typography variant="body-md" sx={{ fontWeight: 700 }}>
				Note:{' '}
			</Typography>
			{children}
		</Typography>
	);
};

export default DestroyNote;
